import { School } from '@mui/icons-material';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PeopleIcon from '@mui/icons-material/People';
import WorkIcon from '@mui/icons-material/Work';
import { Box, styled } from '@mui/material';
import {
  WsDetailsObj,
  WsIconLocation,
  WsIconJobOutline,
  WsIconPersons,
  WsIconVisa,
  WsColors,
} from 'wisestep-base';

import { failed, success, warning } from '../../../../utils/NotificationMessages';

export const LayoutTheme = styled(Box)(() => ({
  maxWidth: '100%',
  maxHeight: 'xs',
  backgroundColor: WsColors.TertiaryShades50,
}));

export const AppLayoutTheme = styled(Box)(() => ({
  borderRadius: 8,
  backgroundColor: WsColors.TheBlues900,
}));

export enum CandidateType {
  SUBMISSIONS = 'submissions',
  TALENTPOOL = 'talentpool',
  PIPELINE = 'pipeline',
  SMART_SOURCE = 'smartSource',
}

export const copySuccess = () => success('Copied Successfully !!');
export const copyFailed = () => failed('Copy failed !! ');
export const copyWarn = () => warning('Clipboard not supported');

export const getBotCandidateDetails = (candidate): WsDetailsObj[] => {
  const array: WsDetailsObj[] = [];
  array.push({
    icon: <WsIconLocation />,
    labelName: candidate.HomeLocation ? candidate.HomeLocation : 'Not Available',
    popOverText: 'Candidate Location',
  });
  array.push({
    icon: <WsIconJobOutline />,
    labelName: candidate.RecentJobTitle ?? 'Not Available',
    popOverText: 'Candidate Profile',
  });
  array.push({
    icon: <WsIconPersons />,
    labelName: candidate.MonthsOfExperience
      ? `Experience: ${candidate.MonthsOfExperience} Months `
      : 'Not Available',
    popOverText: 'Candidate Experience',
  });

  array.push({
    icon: <WsIconVisa />,
    labelName: candidate.HighestDegree
      ? 'Highest Degree: ' + candidate.HighestDegree
      : 'Not Available',
    popOverText: 'Candidate Visa',
  });
  return array;
};

export const searchPatternOptions = [
  { label: 'Match All Keywords', value: 'All' },
  { label: 'Match Any Keywords', value: 'Any' },
  { label: 'Match Exact Keywords', value: 'Exact' },
  { label: 'Match keyword using Boolean Logic', value: 'Boo' },
];
export const miniDegreeCheckBoxOptions = {
  CE31: 'High School',
  CE32: '2 Years Degree',
  CE321: '4 Years Degree',
  CE3210: 'High School',
};

export const languaagesCheckBoxOptions = {
  LAEN: 'English',
  LAES: 'Spanish',
  LAFR: 'French',
  LADE: 'German',
  LARU: 'Russian',
  LAIT: 'Italian',
  LAHI: 'Hindi',
  LAPT: 'Portuguese',
  LAJA: 'Japanese',
  LAAR: 'Arabic',
};

export const employementTypeCheckBoxOptions = {
  All: 'All',
  ETFE: 'Full-Time',
  ETPE: 'Part-Time',
  ETCT: 'Contractor',
  ETIN: 'Intern',
};

export const authorizedCountriesCheckBoxOptions = {
  US: 'United States',
  UK: 'United Kingdom',
  CA: 'Canada',
  IE: 'Ireland',
  IN: 'India',
  IT: 'Italy',
  ES: 'Spain',
  PL: 'Poland',
  BR: 'Brazil',
  LT: 'Lithuania',
  PT: 'Portugal',
  NG: 'Nigeria',
  AU: 'Australia',
  MX: 'Mexico',
  HU: 'Hungary',
};
export const workAuthorizationCheckBoxOptions = {
  CTCT: 'US Citizenship',
  CTGR: 'Green Card',
  CTEM: 'Have H1',
  EAEA: 'Employment Auth Document',
  CTNO: 'Need H1',
  EATN: 'Tn Permit Holder',
  CTNS: 'Not Specified ',
};

export const CompensationOptions = [
  { label: 'Salary', value: 'SALR' },
  { label: 'Hourly', value: 'HOUR' },
];

export const hasSecurityClearanceOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
  { label: 'Either', value: '' },
];

export const currentlyEmployedOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
  { label: 'Either', value: '' },
];

export const militaryExperienceCheckBoxOptions = {
  M1: 'Active Duty',
  M2: 'Reservist-Drilling',
  M3: 'National Guard-Drilling',
  M4: 'Inactive Reserve',
  M5: 'Inactive National Guard',
  M6: 'Retired Military',
  M7: 'Veteran',
};

export const travelPreferenceOptions = [
  { label: 'Not Specified', value: '' },
  { label: 'None', value: 'RTNONE' },
  { label: 'Negligible', value: 'RT3210' },
  { label: 'Up To 25%', value: 'RT321' },
  { label: 'Up To 50%', value: 'RT32' },
  { label: 'Road Warrior', value: 'RT3' },
];

export const managementExperienceOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
  { label: 'Either', value: '' },
];

const workExperience = (monthsOfExperience) => {
  const year = Math.trunc(monthsOfExperience / 12);
  const month = monthsOfExperience % 12;
  let yearInString = '';
  if (year > 0) {
    yearInString = `${year} ${year == 1 ? ' Year' : ' Years'}`;
  }
  let monthInString = '';
  if (month > 0) {
    monthInString = `${month} ${month == 1 ? ' Month' : ' Months'}`;
  }
  return yearInString + ' ' + monthInString;
};
export const getCareerBuilderCandidateDetails = (candidate) => [
  {
    icon: <LocationOnIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `${candidate.HomeLocation}`,
    tooltip: 'Candidate Location',
  },
  {
    icon: <WorkIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `${candidate.candidateData.currentJobTitle}${
      candidate.RecentEmployer ? '@ ' + candidate.RecentEmployer : ''
    }`,
    tooltip: 'Current Job Title',
  },
  {
    icon: <PeopleIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `${workExperience(candidate.MonthsOfExperience)}`,
    tooltip: 'Work Experience',
  },
  {
    icon: <School sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Highest Degree: ${candidate.HighestDegree}`,
    tooltip: 'Education',
  },
  {
    icon: <LibraryBooksIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Recent Job Title: ${candidate.RecentJobTitle}`,
    tooltip: 'Current Job Title',
  },
  {
    icon: <WorkIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Recent Employer: ${candidate.RecentEmployer}`,
    tooltip: 'Current Employer',
  },
  {
    icon: <PeopleIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Source: ${candidate.candidateData.source}`,
    tooltip: 'Source',
  },
];
